import React from 'react'
import GreenBorderline from '../updatehackinginternship/Assets/ProcessAssets/skgreenborder.png'
import orange  from '../updatehackinginternship/Assets/ProcessAssets/orange1.png'
import com from '../updatehackinginternship/Assets/ProcessAssets/Computer.png'
import  blue  from '../updatehackinginternship/Assets/ProcessAssets/Blue1.png'
import paper from '../updatehackinginternship/Assets/ProcessAssets/paper.png'
import green from '../updatehackinginternship/Assets/ProcessAssets/green1.png'
import girl from '../updatehackinginternship/Assets/ProcessAssets/Girl.png'
import red from '../updatehackinginternship/Assets/ProcessAssets/Red1.png'
import books from '../updatehackinginternship/Assets/ProcessAssets/Books.png'

import '../updatehackinginternship/Assets/ProcessAssets/Process.css'



const Process = () => {
  return (
    <div className='process-container'>
    {/* --- HEADER (CYBERSECURITY CONTEXT) --- */}
    <div className='process-header'>
      <h2 style={{ fontSize: "32px", fontWeight: "650", margin: '0px' }}>Admission Process</h2>
      <img src={GreenBorderline} alt="GreenBorderline" style={{ width: "250px", height: "8.59px", marginTop: "-15px" }} />
      <p className='process-header-p text-start'>
        Our goal is to train elite cyber defenders, not just hand out certificates.<br />
        This screening process is mandatory to ensure we enroll candidates with the right aptitude for this high-stakes field.
      </p>
    </div>

    <div className='process-body-container'>
      <div className='process-body'>

        {/* --- CARD 1 (NO CHANGE NEEDED) --- */}
        <div className='process-body-items' style={{ backgroundImage: `url(${orange})` }}>
          <div className='top-part'>
            <div className='title'>Apply on <br />website</div>
          </div>
          <div className='bottom-part' style={{ gap: '2em' }}>
            <div className='desc'>Fill out the application form on our website with your details and submit it for review.</div>
            <img className='card-img' src={com} alt="computer" />
          </div>
        </div>

        {/* --- CARD 2 (CYBERSECURITY CONTEXT) --- */}
        <div className='process-body-items' style={{ backgroundImage: `url(${blue})` }}>
          <div className='top-part'>
            <div className='title'>Take the<br />Aptitude Challenge</div>
          </div>
          <div className='bottom-part'>
            <div className='desc'>You'll get security videos, then take an aptitude test and a basic CTF. You have 3 attempts. Attempt within 3 days to qualify for the 'Cyber Security' scholarship."</div>
            <img className='card-img' src={paper} alt="paper" />
          </div>
        </div>

        {/* --- CARD 3 (CYBERSECURITY CONTEXT) --- */}
        <div className='process-body-items' style={{ backgroundImage: `url(${green})` }}>
          <div className='top-part'>
            <div className='title'>Talk to an<br />Advisor</div>
          </div>
          <div className='bottom-part' style={{ gap: '1.4em' }}>
            <div className='desc'>An advisor will contact you to review results, discuss goals, and confirm fit</div>
            <img className='card-img' src={girl} alt="girl" />
          </div>
        </div>

        {/* --- CARD 4 (CYBERSECURITY CONTEXT) --- */}
        <div className='process-body-items' style={{ backgroundImage: `url(${red})` }}>
          <div className='top-part'>
            <div className='title'>Enroll and start<br />your mission</div>
          </div>
          <div className='bottom-part' style={{ gap: '0.3em' }}>
            <div className='desc'>If accepted, you can complete the payment formalities and get started with the program.</div>
            <div className='welcome'>Welcome to the team, hacker!</div>
            <img className='card-img' src={books} alt="books" />
          </div>
        </div>

      </div>
    </div>

  </div>
  )
}

export default Process








 
  
   
   

        